module.exports = __webpack_public_path__ + "static/img/fefco216_2.41e3330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco216_2.png
// module id = fXSj
// module chunks = 0